import { SectionTemplateModel } from './section-template.model';

/**
 * ページテンプレートVO
 *
 * @export PageTemplateModel
 * @class PageTemplateModel
 */
export class PageTemplateModel {
  public mediaGroup = String('');
  public pageTemplateID = String('');
  public pageTemplateName = String('');
  // 項番2231 START 障害管理NO.I00458対応
  // public pageAreaX: number = Number(0);
  // public pageAreaY: number = Number(0);
  // public pageAreaWidth: number = Number(0);
  // public pageAreaHeight: number = Number(0);
  public pageAreaX = String(0);
  public pageAreaY = String(0);
  public pageAreaWidth = String(0);
  public pageAreaHeight = String(0);
  // 項番2231 END 障害管理NO.I00458対応
  public divW = Number(0);
  public divH = Number(0);
  public _sectionList: Array<SectionTemplateModel> = new Array<SectionTemplateModel>();

  /**
   * セクション追加
   *
   * @param {SectionTemplateModel} newSection
   * @memberof PageTemplateModel
   */
  public addSection(newSection: SectionTemplateModel): void {
    this._sectionList.push(newSection);
  }

  /**
   * セクションリスト取得
   *
   * @readonly
   * @type {Array<SectionTemplateModel>}
   * @memberof PageTemplateModel
   */
  public get sectionList(): Array<SectionTemplateModel> {
    return this._sectionList;
  }
}
